import jsPDF from "jspdf";
import { font, fontBold } from "@/assets/fonts/Sarabun-normal.js";

export default {
    methods: {
        async generatePdf() {
            try {
                this.isDisableDownloadReportBtn = true;

                let pdf = new jsPDF(this.pdfOption);

                const pdf_width = pdf.internal.pageSize.width;
                const pdf_height = pdf.internal.pageSize.height;

                const margin_l = this.pdfConfig.margin.l;
                const margin_t = this.pdfConfig.margin.t;
                const margin_b = this.pdfConfig.margin.b;

                let cellHeight = 35;

                const addNewPageIfNeeded = (incrementValue) => {
                    if ((pdf_position_y + incrementValue) >= pdf_height - margin_t) {
                        pdf.addPage();
                        pdf_position_y = margin_t; // Reset the position to the top of the new page
                    } else {
                        pdf_position_y += incrementValue; // Add the input value
                    }
                };

                let pdf_position_y = 0;
                pdf.addFileToVFS("Sarabun-Regular.ttf", fontBold);
                pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "bold");
                pdf.addFileToVFS("Sarabun-Regular.ttf", font);
                pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "normal");

                pdf.setFont("Sarabun", "bold");
                pdf.setFontSize(this.pdfConfig.typo.header);
                pdf_position_y += margin_t;
                this.thaitext(
                    pdf,
                    "รายงานการจบคอร์สและสอบผ่าน",
                    (pdf_width / 2),
                    pdf_position_y,
                    0,
                    "center"
                );
                addNewPageIfNeeded(this.pdfConfig.endLarge);

                pdf.setFont("Sarabun", "normal");
                pdf.setFontSize(this.pdfConfig.typo.extraSmall);

                this.thaitext(
                    pdf,
                    "วันที่พิมพ์ : " + ' ' + this.formatDateToThai(this.moment().format("YYYY-MM-DD"), false),
                    pdf_width - 40,
                    pdf_position_y,
                    0,
                    "right"
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                let hasCompletedDate = this.dateRange.start ? true : false
                let startDate = this.moment(this.dateRange.start).format("YYYY-MM-DD");
                let endDate = this.moment(this.dateRange.end).format("YYYY-MM-DD");
                this.thaitext(
                    pdf,
                    "วันที่จบคอร์สและสอบผ่าน : " + (hasCompletedDate ? this.formatDateToThai(startDate, false) + ' - ' + this.formatDateToThai(endDate, false) : '-'),
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endRow);

                const tableHeader = ["เลขที่ใบอนุญาต\nประกันชีวิต", "เลขที่ใบอนุญาต\nประกันวินาศภัย", "ชื่อ", "นามสกุล", "วันที่จบคอร์ส\nและสอบผ่าน", "จำนวนคอร์ส\nทั้งหมด"];
                const colWidths = [60, 60, 70, 70, 60, 50];
                let headerX = 40;
                pdf.setLineWidth(0.1);
                pdf.setFont("Sarabun", "bold");

                const fontSize = pdf.getFontSize();
                const fontHeight = fontSize * 0.3528;
                const lineSpacing = 8; // Extra padding between multiline texts

                for (let i = 0; i < tableHeader.length; i++) {
                    const width = colWidths[i];

                    // 1. Draw Header Cell Border
                    pdf.rect(headerX, pdf_position_y, width, cellHeight);

                    // 2. Split text by newline for multiline support
                    const lines = tableHeader[i].split('\n');
                    const totalLines = lines.length;

                    // Calculate the starting Y position so the entire block of text is vertically centered
                    const totalTextHeight = (totalLines * fontHeight) + ((totalLines - 1) * lineSpacing);
                    let startY = pdf_position_y + (cellHeight - totalTextHeight) / 2 + fontHeight;

                    // 3. Loop through and center each individual line
                    for (let j = 0; j < totalLines; j++) {
                        const lineText = lines[j];

                        // Calculate horizontal center for the current line
                        const textWidth = pdf.getStringUnitWidth(lineText) * fontSize / pdf.internal.scaleFactor;
                        const textX = headerX + (width - textWidth) / 2;

                        // Render the text using your custom Thai text function
                        this.thaitext(pdf, lineText, textX, startY);

                        // Move Y down for the next line
                        startY += fontHeight + lineSpacing;
                    }

                    headerX += width;
                }
                pdf_position_y += cellHeight;

                pdf.setFont("Sarabun", "normal");
                cellHeight = 20
                let finalRowHeight = Math.max(cellHeight);

                const maxPrintableY = pdf_height - margin_b;

                this.completedCourses.forEach((row) => {
                    let columnX = margin_l;
                    const padding = 10;

                    const lifeId = row.life_id ? row.life_id.toString() : '-';
                    const nonLifeId = row.non_life_id ? row.non_life_id.toString() : '-';
                    const firstNameLines = pdf.splitTextToSize(row.mp_firstName, colWidths[2] - padding);
                    const lastNameLines = pdf.splitTextToSize(row.mp_lastName, colWidths[3] - padding);

                    // 1. Split long text into arrays of wrapped lines
                    // const padding = 10;

                    // 2. Calculate heights for individual text blocks
                    const fontHeight = pdf.getFontSize() * 0.3528;
                    const lineSpacing = 5;
                    const calculatedFirstNameHeight = (firstNameLines.length * fontHeight) + ((firstNameLines.length - 1) * lineSpacing) + 10;
                    const calculatedLastNameHeight = (lastNameLines.length * fontHeight) + ((lastNameLines.length - 1) * lineSpacing) + 10;

                    finalRowHeight = Math.max(cellHeight, calculatedFirstNameHeight, calculatedLastNameHeight);

                    // ==========================================
                    // CRITICAL FIX: AUTOMATIC PAGE BREAK CHECK
                    // ==========================================
                    if (pdf_position_y + finalRowHeight > maxPrintableY) {
                        pdf.addPage();
                        pdf_position_y = margin_t; // Reset to the top of the new page

                        // RE-DRAW TABLE HEADERS ON THE NEW PAGE
                        let headerX = margin_l;
                        pdf.setLineWidth(0.1);

                        for (let i = 0; i < tableHeader.length; i++) {
                            const width = colWidths[i];
                            pdf.rect(headerX, pdf_position_y, width, cellHeight); // assumes global cellHeight for headers

                            const lines = tableHeader[i].split('\n');
                            const totalLines = lines.length;
                            const totalTextHeight = (totalLines * fontHeight) + ((totalLines - 1) * 2);
                            let startY = pdf_position_y + (cellHeight - totalTextHeight) / 2 + fontHeight;

                            for (let j = 0; j < totalLines; j++) {
                                const textWidth = pdf.getStringUnitWidth(lines[j]) * pdf.getFontSize() / pdf.internal.scaleFactor;
                                this.thaitext(pdf, lines[j], headerX + (width - textWidth) / 2, startY);
                                startY += fontHeight + 2;
                            }
                            headerX += width;
                        }
                        // Move Y position down past the header block
                        pdf_position_y += cellHeight;
                    }
                    // ==========================================

                    // --- DRAW COLUMN 1: Life Id ---
                    pdf.rect(columnX, pdf_position_y, colWidths[0], finalRowHeight);
                    this.thaitext(pdf, lifeId, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                    columnX += colWidths[0];

                    // --- DRAW COLUMN 2: Non Life Id ---
                    pdf.rect(columnX, pdf_position_y, colWidths[1], finalRowHeight);
                    this.thaitext(pdf, nonLifeId, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                    columnX += colWidths[1];

                    // --- DRAW COLUMN 3: First Name ---
                    pdf.rect(columnX, pdf_position_y, colWidths[2], finalRowHeight);
                    const totalFirstNameHeight = (firstNameLines.length * fontHeight) + ((firstNameLines.length - 1) * lineSpacing);
                    let firstNameY = pdf_position_y + (finalRowHeight - totalFirstNameHeight) / 2 + fontHeight;
                    firstNameLines.forEach((line) => {
                        this.thaitext(pdf, line, columnX + 5, firstNameY);
                        firstNameY += fontHeight + lineSpacing;
                    });
                    columnX += colWidths[2];

                    // --- DRAW COLUMN 4: Last Name ---
                    pdf.rect(columnX, pdf_position_y, colWidths[3], finalRowHeight);
                    const totalLastNameHeight = (lastNameLines.length * fontHeight) + ((lastNameLines.length - 1) * lineSpacing);
                    let lastNameY = pdf_position_y + (finalRowHeight - totalLastNameHeight) / 2 + fontHeight;
                    lastNameLines.forEach((line) => {
                        this.thaitext(pdf, line, columnX + 5, lastNameY);
                        lastNameY += fontHeight + lineSpacing;
                    });
                    columnX += colWidths[3];

                    // --- DRAW COLUMN 5: Complete Date ---
                    pdf.rect(columnX, pdf_position_y, colWidths[4], finalRowHeight);
                    this.thaitext(pdf, this.formatDateToThaiShort(row.cer_completeDate), columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                    columnX += colWidths[4];

                    // --- DRAW COLUMN 6: Course Count ---
                    pdf.rect(columnX, pdf_position_y, colWidths[5], finalRowHeight);
                    const courseCountText = (row.total_course).toString();
                    const courseCountWidth = pdf.getStringUnitWidth(courseCountText) * pdf.getFontSize() / pdf.internal.scaleFactor;
                    this.thaitext(pdf, (row.total_course).toString(), columnX + (colWidths[5] - courseCountWidth) / 2, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                    columnX += colWidths[5];

                    // 4. Move Y down cleanly by the shared unified row height
                    pdf_position_y += finalRowHeight;
                });

                setTimeout(() => {
                    pdf.save("รายงานการจบคอร์สและสอบผ่าน.pdf");
                }, 0);
                this.isDisableDownloadReportBtn = false;
            } catch (error) {
                console.log(error)
            }
        }
    }
}